export const PALLETTE = {
  statusbar: "#F0F3F9",
  white: "#FFFFFF",
  background: "#F0F3F9",
  selectedBlue: "#1F78F1",
  buttonBlue: "#1976D2",
  red: "#EA5454",
  redShade1: "#FFDEDE",
  blue: "#2129EE",
  blueShade1: "#7B8AD8",
  yellow: "#EAB857",
  yellowShade1: "#FFFADF",
  grayOpaque: "#A0A6B81A",
  gray: "#A0A6B8",
  grayShade1: "#7C868A",
  grayShade2: "#E5E5E5",
  chip: "#E5E7EA",
  green: "#45AF50",
  greenShade1: "#E3F9E0",
  greenShade2: "#C3CDEE",

  dark: "#00000",

  orange: "#F7B712",
  blackOpacity: "#545C62",
  borderBlue: "#99D1FF",
  blueBorderShade1: "#E3F2FD",
  bgBlue: "rgba(0, 141, 255, 0.1)",
  bgGreen: "rgba(170, 255, 0, 0.1)",
  borderGreen: "rgba(170, 255, 0, 1)",
  senderBlue: "#42A5F5",
  link: "#0659FD",
};
